import { SlicePipe } from '@angular/common';
import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { DevicesManagerService } from '../../../services/devices-manager.service';
import { HardwareService } from '../../../services/hardware.service';
import { PermissionService } from '../../../services/permission.service';
import { DEVICES_DIAGNOSTIC } from '../../devices/devices-routing.constants';
import { DeviceCardComponent } from '../../shared/card/device-card/device-card.component';

@Component({
  selector: 'widget-diagnostic',
  templateUrl: './widget-diagnostic.component.html',
  styleUrls: ['./widget-diagnostic.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, RouterLink, MatTooltipModule, SlicePipe, DeviceCardComponent, MatIconModule],
})
export class WidgetDiagnosticComponent {
  private hardwareService = inject(HardwareService);
  public permissionService = inject(PermissionService);
  private _devicesManagerService = inject(DevicesManagerService);
  public $devicesWithDiagnostic = this._devicesManagerService.$devicesWithWarning;
  public $hardwares = this.hardwareService.$values;
  public $devices = computed(() => {
    if (this.$devicesWithDiagnostic() && this.$hardwares()) {
      return this.$devicesWithDiagnostic().filter(
        device => !device.hasBeacon && !this.$hardwares()?.[device.hardware]?.isSecure
      );
    }
  });
  public readonly DEVICES_DIAGNOSTIC = DEVICES_DIAGNOSTIC;
}
